import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';

export const startOver = css({
  margin: '31px 0 56px',
  textAlign: 'center',
  [MediaQueries.mdAndUp]: {
    marginBottom: 96,
    marginTop: 47,
  },
});

export const startOverCta = css({
  color: colorsPalette.black,
  cursor: 'pointer',
  paddingLeft: 26,
  position: 'relative',
  '&:visited, &:link': {
    textDecoration: 'none',
  },
  '&:hover, &:focus, &:active': {
    '.text': {
      borderBottom: `1px solid ${colorsPalette.grey60}`,
    },
  },
});

export const startOverCtaIcon = css({
  left: 0,
  position: 'absolute',
  top: 2,
});

export const startOverCtaCopy = css({
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  paddingBottom: 3,
});
